import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';

import { routes } from './app.routes';
import { themeConfig } from '@tecnologia_isimo/shared-ui-components-v20';
import { authInterceptor } from './core/interceptors/auth.interceptor';

// NOTA: providers a nivel de configuración/infraestructura solamente.
// Cuando se implementen los servicios de dominio (secciones 6-9 del blueprint) añadir aquí:
//   { provide: ErrorHandler, useClass: ChunkErrorHandler },
//   ...provideInterceptor(), ...provideLocationRef(), provideFieldsApplicabilityInitializer(),
// y cambiar provideRouter(routes) por provideRouter(routes, withDisabledInitialNavigation())
// disparando router.initialNavigation() manualmente en app.ts.
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    // `withComponentInputBinding` enlaza params y `data` de la ruta a los inputs del
    // componente: así `bandejas/:bandeja` alimenta el input `bandeja` sin código extra.
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),
    CookieService,
    MessageService,
    providePrimeNG({ ...themeConfig }),
    provideLuxonDateAdapter(),
  ],
};
